import { Section as BaseSection } from "../components/Section";
import * as React from "react";
import styled from "styled-components";
import LogoBaseline from "../assets/images/LogoBaseline2.svg";
import instagram from "../assets/images/insta.svg";
import facebook from "../assets/images/facebook.svg";
import linkedin from "../assets/images/linkedin.svg";
import greenNoise from "../assets/images/green_noise.jpg";
import { ContactUs } from "../components/ContactUs";
import { TABLET } from "../constant/Breakpoints";

const Section = styled(BaseSection)`
  background: url("${greenNoise}");
  padding-top: 0;
  padding-bottom: 0;
`;

const Foot = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${TABLET}px) {
    justify-content: center;
    flex-direction: column-reverse;
  }
`;

const BottomOrLeftElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: ${TABLET}px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    width: 100%;
  }
`;

const TopOrRightElement = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  @media (max-width: ${TABLET}px) {
    margin-bottom: 64px;
  }
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  margin-top: 15px;

  @media (max-width: ${TABLET}px) {
    align-items: flex-end;
  }
`;

const P = styled.p`
  font-family: Ubuntu;
  font-size: 18px;
  font-weight: 900;
  text-align: center;
  color: white;
  margin: 0;
`;

const SmallP = styled.div`
  font-family: Ubuntu;
  font-size: 12px;
  text-align: center;
  color: white;
`;

const Networks = styled.div`
  display: flex;
  margin: 24px 0;
  align-self: flex-end;

  > a {
    margin: 0 6px;
  }

  @media (max-width: ${TABLET}px) {
    align-self: center;
  }
`;

export const Footer = () => (
  <footer>
    <Section noAnimation={true}>
      <Foot>
        <BottomOrLeftElement>
          <img
            src={LogoBaseline}
            alt="Le C : Collectif Créatif Climat"
            style={{ width: 200 }}
          />
          <Details>
            <SmallP>Création | Stratégie | Tech</SmallP>
            <SmallP>© Le C! 2020</SmallP>
            <SmallP as="a" href="/legal">
              Mentions légales
            </SmallP>
          </Details>
        </BottomOrLeftElement>
        <TopOrRightElement>
          <P>On croit déjà en vous !</P>
          <Networks>
            <a
              href="https://www.instagram.com/collectif_creatif_climat/"
              target="_blank"
            >
              <img src={instagram} height={28} width={28} alt="instagram" />
            </a>
            <a
              href="https://www.facebook.com/Le-C-Collectif-Cr%C3%A9atif-Climat-110421150655737"
              target="_blank"
            >
              <img src={facebook} height={28} width={28} alt="facebook" />
            </a>
            <a
              href="https://www.linkedin.com/company/lec-crew/"
              target="_blank"
            >
              <img src={linkedin} height={28} width={28} alt="linkedin" />
            </a>
          </Networks>
          <ContactUs />
        </TopOrRightElement>
      </Foot>
    </Section>
  </footer>
);
